import React, { type ComponentProps, type FC } from 'react';
import { MiniCartButton as ModuleQuoteMiniCartButton } from '@kidslabs/module-quote';

type MiniCartButtonProps = ComponentProps<typeof ModuleQuoteMiniCartButton>;

export const MiniCartButton: FC<MiniCartButtonProps> = props => {
    return <ModuleQuoteMiniCartButton {...props} />;
};
